// extracted by mini-css-extract-plugin
module.exports = {"root":"AddInfoBlock_root__QQx7R","button":"AddInfoBlock_button__181qx","active":"AddInfoBlock_active__1XM4q","icon":"AddInfoBlock_icon__1Wlc6"};